import { render, staticRenderFns } from "./Contrast.vue?vue&type=template&id=8a43fd0a&scoped=true&"
import script from "./Contrast.vue?vue&type=script&lang=js&"
export * from "./Contrast.vue?vue&type=script&lang=js&"
import style0 from "./Contrast.vue?vue&type=style&index=0&id=8a43fd0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a43fd0a",
  null
  
)

export default component.exports